export default "__VITE_ASSET__D$nP8Lx1__"